(function(){
    var FormSubmitButton = function ($el) {
        this.$el = $el
        this.$form = this.$el.closest('form')

        this.$el.on('click', this.disableAndSubmit.bind(this))
        
        return this
    }

    FormSubmitButton.prototype.disableAndSubmit = function () {
        this.$el.prop('disabled', true)
        this.renderButtonAsInput()
        this.animate()
        this.$form.submit()

        return this
    }

    FormSubmitButton.prototype.animate = function () {
        this.$el.children()
            .hide()

        this.$el.find('.glyphicon-refresh')
            .removeClass('collapse')
            .fadeIn()

        return this
    }

    FormSubmitButton.prototype.renderButtonAsInput = function () {
        var $input = $('<input>')
            .attr('name', this.$el.attr('name'))
            .attr('type', 'hidden')
            .val(this.$el.val())

        this.$form.append($input)

        return this
    }

    $('.btn-disable-on-submit').each(function () {
        new FormSubmitButton($(this))
    })
})()
